<template>
<div class="chapter">
<div class="inner_page">
<div><a id="c5"></a></div>
<div class="xpage">
<h4 class="chaptitle"><a href="#/html/003_toc#c5_">ON THE AFRICAN-AMERICAN COMMUNITY</a></h4>
<p class="textfirst">I don’t think the Democratic Party takes the African-American voters for granted. I want Republicans to compete for the African-American vote. They’re not
    getting the African-American vote not because African-Americans aren’t open-minded, but because Democrats have consistently championed those issues—civil rights, voting rights,
    concern for working families—that are of greatest concern to African-American voters.</p>
<p class="right2"><em>Meet the Press</em>, July 25, 2004</p>
</div>
<div class="xpage">
<p class="textfirst2">In the African-American community in particular, I think sometimes we have a tendency for our leadership to be very protective of their turf and not invite young people in
    until it’s way too late. The earlier we’re grooming young people and giving them leadership opportunities, and pushing them up front, the better.</p>
<p class="right2"><em>Black Collegian</em>, October 2006</p>
</div>
<div class="xpage">
<p class="textfirst2">I firmly believe the overwhelming majority of African-Americans are just as hardworking, just as intent to go about their business. What is true, though, is sometimes we
    get into the mode of it’s easier to blame white folks for things than us taking the responsibility.</p>
<p class="right2"><em>Who’s Afraid of a Large Black Man?</em> Charles Barkley, page 35</p>
</div>
<div class="xpage">
<p class="textfirst2">We have a certain script in our politics, and one of the scripts for black politicians is that for them to be authentically black they have to somehow offend white people.
    And then if he puts a multiracial coalition together, he must somehow be compromising the efforts of the African-American community. To use a street term, we flipped the script.</p>
<p class="right2"><em>Chicago Tribune</em>, June 26, 2005</p>
</div>
<div class="xpage">
<p class="textfirst2">I think that it is the best of times and the worst of times for the African-American community. And one of the things that I want to make certain is that the voices of
    young men standing on a street corner without hope and vision for the future. Voices are heard in the U.S. Senate, that we feel a certain sense of urgency about a generation that we’re
    losing.</p>
<p class="right2"><em>All Things Considered</em>, July 27, 2004</p>
</div>
<div class="xpage">
<p class="textfirst2">Any black person in America who’s successful has to be able to speak several different forms of the same language. You take on different personas as you need to, when
    you have to. There’s nothing wrong with it. You’re going to speak differently on the golf course with your golf buddies than you are with your buddies around the kitchen table.</p>
<p class="right2"><em>Who’s Afraid of a Large Black Man?</em> Charles Barkley, page 25</p>
</div>
<div class="xpage">
<p class="textfirst2">I know if I’m in an all-black audience that there’s going to be a certain rhythm coming back at me from the audience. They’re not just going to be sitting
    there. That creates a different rhythm in your speaking.</p>
<p class="right2"><em>Chicago Tribune</em>, June 26, 2005</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011_chap5.vue?564b76eb